export default "__VITE_ASSET__CA19IMAQ__"